import { connect } from "react-redux";
import SoftwareRmTickets from "./softwareRmTicket";
import { bindActionCreators } from "redux";
import {fetchRmSoftwareTicket, getRmSoftwareTicketsFilterDropDown} from "services/redux/maintenance/softwareRmTicket/action";
const mapStateToProps = (state) => ({
    rmSoftwareTicket: state.softwareRmTicketReducer.rmSoftwareTicket,
    rmSoftwareTicketFilter: state.softwareRmTicketReducer.rmSoftwareTicketFilter
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchRmSoftwareTicket,
      getRmSoftwareTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareRmTickets);
